import { Injectable } from '@angular/core';
import { EzoomApiProvider } from './ezoom-api';

/*
  Generated class for the TermoAutorizacaoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TermoAutorizacaoProvider {

  constructor(
    public api: EzoomApiProvider
  ) {}

  setAutorizacao(autorizacao:boolean, id:string, sequency:string){
    const att = (autorizacao? 'S': 'N');
    return new Promise((resolve, reject)=>{
      this.api.post('direito_imagem/setAutorizacao', {att: att, id: id, seq: sequency}).subscribe((response:any) =>{
        if (response.status){
          resolve(response.data);
      }else{
          reject(response.data);
      }
      })
    });
  }

  getAutorizacao(id:string, sequency:string){
    return new Promise((resolve, reject)=>{
      this.api.post('direito_imagem/getAutorizacao', {id: id, seq: sequency}).subscribe((response:any) =>{
        if (response.status){
          resolve(response.data);
      }else{
          reject(response.data);
      }
      })
    });
  }

  getPolitica(){
    return new Promise((resolve, reject)=>{
      this.api.get('politica_de_privacidade').subscribe((response:any)=>{
        if(response.status)
          resolve(response.data);
        else
          reject(response.data);
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/termo-autorizacao.ts